import React, { Component } from "react";
import { Row, Col, Modal } from "antd";
import "./AddUser.css";

export default class DeleteModal extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  };

  handleCancel = () => {
    this.props.handleCancel();
  };

  handleOk = () => {
    this.props.handleOk();
  };

  render() {
    return (
      <>
        <Modal
           
            visible={this.props.deleteModal}
          onCancel={this.props.handleCancel}
          centered
          close={false}
          footer={null}
          width={400}
          closable={false}
          >
            <div>
            <Row>
              <Col span={24}>
                <div className="modal-delete mb-1"> Are you sure to Delete?</div>
              </Col>
              <Col span={24} className="question-css">
                This will discard combination permanently!
              </Col>
            </Row>

            <Row className="pt-5 pb-2" justify="space-between"> 
            <Col span={12}>
          <button
                className="cancle-button px-4"
                onClick={this.handleCancel}
              >
                No
              </button>
              
          </Col>

          <Col span={12}>
          <button
                className="delete-alluser danger px-4"
                onClick={this.handleOk}
              >
                Yes, Delete
              </button>
          </Col>
            </Row>
            </div>
            
          </Modal>
      </>
    )
    
  }
}
